import {Component, Prop, Vue} from '@/node_modules/nuxt-property-decorator';
import MListNews from '@/components/module/MListNews.vue';
import {DummyMNews} from '@/configs/dummy/dummy-m-news';

@Component({
    components: {
	    MListNews
    }
})
export default class MSelectNews extends Vue {
   	
    public articles: any = DummyMNews;
	
    ////////// POPUP LAYER 共通処理 /////////////////////////////////
	public onClose(to: string=''): any {
		if(to != ''){
			this.$router.push(to);
		}
        this.$emit('close');
	}
	
	
}
